/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import PageHero from '../containers/Pages/PageHero';
import VideoGallery from '../containers/Pages/VideoGallery';
import HomeFooter from '../containers/Home/HomeFooter';

const Videos = () => (
  <div>
    <PageHero
      meta={['Vol. 03 — On Film', 'Mastered Trax VEVO']}
      eyebrow="Videos & Sessions"
      title="La música,"
      italic="hecha imagen."
      lede="Estrenos oficiales, sesiones de estudio y performances en vivo — el archivo audiovisual del sello."
    />
    <VideoGallery />
    <HomeFooter />
  </div>
);

export default Videos;
